// extracted by mini-css-extract-plugin
export default {"wrap":"ID-z","subtitle":"JD-z","contentWrap":"KD-z","imgWrap":"LD-z","heading":"MD-z","copy":"ND-z"};